import { render, staticRenderFns } from "./new-home.vue?vue&type=template&id=5d093e19"
import script from "./new-home.vue?vue&type=script&lang=js"
export * from "./new-home.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductCollection: require('C:/cata1og/cata1og-store/components/product/product-collection.vue').default})
